<template>
<div class="org-canuse-modal">
    <p class="p1">普通用户查询数量受限</p>
    <p class="p2">开通动脉橙机构版，可查看完整内容</p>
    <div @click="go" class="go-vip-btn">申请试用</div>
</div>
</template>

<script>
export default {
  props: ['which'],
  methods: {
      setClass() {
          document.querySelectorAll(".org-canuse-modal")[0].classList.add(this.which)
      },
      go() {
        let link = this.$store.state.index_path + '/applyTry?info_src=36'
        window.open(link)
      }
  },
  mounted() {
      this.setClass()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.org-canuse-modal
  &.zgsgs
    commonBgImg('~pic/yunying/black-zgsgs.png', '~pic/yunying/white-zgsgs.png') no-repeat;
    height: 285px;
  &.zgs
    commonBgImg('~pic/yunying/black-zgs.png', '~pic/yunying/white-zgs.png') no-repeat;
    height: 256px;
  &.hd
    commonBgImg('~pic/yunying/black-hd.png', '~pic/yunying/white-hd.png') no-repeat;
    height: 256px;
  &.gg
    commonBgImg('~pic/yunying/black-gg.png', '~pic/yunying/white-gg.png') no-repeat;
    height: 276px;
  &.cpxxgs
    commonBgImg('~pic/yunying/black-cpxxgs.png', '~pic/yunying/white-cpxxgs.png') no-repeat;
    height: 257px;
  &.cpsj
    commonBgImg('~pic/yunying/black-cpsj.png', '~pic/yunying/white-cpsj.png') no-repeat;
    height: 313px;
  &.cwsj
    commonBgImg('~pic/yunying/black-cwsj.png', '~pic/yunying/white-cwsj.png') no-repeat;
    height: 316px;
  &.hgsj
    commonBgImg('~pic/yunying/black-hgsj.png', '~pic/yunying/white-hgsj.png') no-repeat;
    height: 337px;
  background-size: 100%
  text-align: center
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  .p1
    commonColor(#bcbdc1, #553204)
    font-size: 24px
    font-weight:600
  .p2
    commonColor(#bcbdc1, #553204)
    font-size: 16px
    margin-top: 12px
  .go-vip-btn
    width:150px
    height:40px
    background:rgba(255,234,197,1)
    border-radius:20px
    color: #553204
    font-size:14px
    text-align: center
    line-height: 40px
    margin-top: 40px
    cursor pointer
</style>
